import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import ProfilePicture from './profile-picture';
import EmailAddress from './email-address';
import Password from './password';
import TimeZone from './time-zone';
import MoreAboutYou from './more-about-you';
import ForumsUsername from './forums-username';
import { smoothScrollToElement } from '../../../scroll';
import { MediaQuery as MQ } from '../../../media-query';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.getDetails();

        this.genders = {
            female: 'FEMALE',
            male: 'MALE',
            na: 'NONE OF YOUR BUSINESS',
        };

        this.relationships = {
            'Married': 'Married',
            'In a Relationship': 'In a Relationship',
            'Dating': 'Dating',
            'Single not looking': 'Single Not Looking',
            'Single and happy that way!': 'Single and Happy That Way!',
            'Open to anything': 'Open to Anything',
        };

        this.orientations = {
            'Straight': 'STRAIGHT',
            'Gay': 'GAY',
            'Bisexual': 'BI-SEXUAL',
            'None of your business': 'NONE OF YOUR BUSINESS',
        };

        props.settingsUpdate({
            success: false,
            errors: [],
            fields: [],
            error: false,
            dirty: false,
        });
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.route != this.props.route) {
            this.props.settingsUpdate({
                success: false,
                errors: [],
                fields: [],
                error: false,
                dirty: false,
            });

            return true;
        }

        if (nextProps.settings != this.props.settings) {
            return true;
        }

        return false;
    }

    render({ route, settings }) {
        if (settings) {
            return (
                <account-settings>
                    <row className='is-aligned-center' id='account-your-profile-picture'>
                        <column className='is-10 has-padding-10'>
                            <a href='#account-your-profile-picture' onClick={this.scrollTo}>
                                <h4>Your Profile Picture</h4>
                            </a>
                        </column>
                        <column className='is-2 has-padding-10-right has-text-right'>
                            <a href='#account-your-profile-picture' onClick={this.scrollTo}>Edit</a>
                        </column>
                    </row>
                    <row className={`is-wrap ${route == 'account-your-profile-picture' ? '' : 'is-hidden' }`}>
                        <column className='is-12'>
                            <p>Update your profile picture</p>
                            <ProfilePicture onChange={this.handleChange} submit={this.submit} />
                        </column>
                        {this.renderButton()}
                    </row>
                    <row className='is-aligned-center' id='account-your-email-address'>
                        <column className='is-10 has-padding-10'>
                            <a href='#account-your-email-address' onClick={this.scrollTo}>
                                <h4>Your Email Address</h4>
                            </a>
                        </column>
                        <column className='is-2 has-padding-10-right has-text-right'>
                            <a href='#account-your-email-address' onClick={this.scrollTo}>Edit</a>
                        </column>
                    </row>
                    <row className={`is-wrap ${route == 'account-your-email-address' ? '' : 'is-hidden'}`}>
                        <column className='is-12'>
                            <p>Update your login email address</p>
                            <EmailAddress onChange={this.handleChange} />
                            <p><a href='/member/settings/email-preferences'>Update your email preferences</a></p>
                        </column>
                        {this.renderButton()}
                    </row>
                    <row className='is-aligned-center' id='account-your-password'>
                        <column className='is-10 has-padding-10'>
                            <a href='#account-your-password' onClick={this.scrollTo}>
                                <h4>Your Password</h4>
                            </a>
                        </column>
                        <column className='is-2 has-padding-10-right has-text-right'>
                            <a href='#account-your-password' onClick={this.scrollTo}>Edit</a>
                        </column>
                    </row>
                    <row className={`is-wrap ${route == 'account-your-password' ? '' : 'is-hidden'}`}>
                        <column className='is-12'>
                            <p>Update your account password</p>
                            <Password onChange={this.handleChange} />
                        </column>
                        {this.renderButton()}
                    </row>
                    <row className='is-aligned-center' id='account-your-timezone'>
                        <column className='is-10 has-padding-10'>
                            <a href='#account-your-timezone' onClick={this.scrollTo}>
                                <h4>Your Timezone</h4>
                            </a>
                        </column>
                        <column className='is-2 has-padding-10-right has-text-right'>
                            <a href='#account-your-timezone' onClick={this.scrollTo}>Edit</a>
                        </column>
                    </row>
                    <row className={`is-wrap ${route == 'account-your-timezone' ? '' : 'is-hidden'}`}>
                        <column className='is-12'>
                            <p>Update your Time Zone</p>
                            <TimeZone onChange={this.handleChange} />
                        </column>
                        {this.renderButton()}
                    </row>
                    <row className='is-aligned-center' id='account-more-about-you'>
                        <column className='is-10 has-padding-10'>
                            <a href='#account-more-about-you' onClick={this.scrollTo}>
                                <h4>More About You</h4>
                            </a>
                        </column>
                        <column className='is-2 has-padding-10-right has-text-right'>
                            <a href='#account-more-about-you' onClick={this.scrollTo}>Edit</a>
                        </column>
                    </row>
                    <row className={`is-wrap ${route == 'account-more-about-you' ? '' : 'is-hidden'}`}>
                        <column className='is-12'>
                            <p>Update to help us customize your experience</p>
                            <MoreAboutYou onChange={this.handleChange} />
                        </column>
                        {this.renderButton()}
                    </row>
                    <row className='is-aligned-center' id='account-forums-username'>
                        <column className='is-10 has-padding-10'>
                            <a href='#account-forums-username' onClick={this.scrollTo}>
                                <h4>Forums Username</h4>
                            </a>
                        </column>
                        <column className='is-2 has-padding-10-right has-text-right'>
                            <a href='#account-forums-username' onClick={this.scrollTo}>Edit</a>
                        </column>
                    </row>
                    <row className={`is-wrap ${route == 'account-forums-username' ? '' : 'is-hidden'}`}>
                        <column className='is-12'>
                            <p className='has-padding-20-right'>
                                Your unique username will allow you to post and reply to topics in our&nbsp;
                                <a href='https://forums.tarot.com'>Tarot.com forums</a> and personalize your forums
                                profile page.
                            </p>
                            <ForumsUsername onChange={this.handleChange} />
                        </column>
                        {
                            this.props.user.forum_name
                                ? (
                                    <a
                                        href={
                                            'https://forums.tarot.com/user/' +
                                            `${this.props.user.forum_name.replace(/\s+/g, '-')}`
                                        }
                                        target='_blank'
                                        rel='noopener'
                                    >
                                        View Your Forums Profile
                                    </a>
                                )
                                : this.renderButton()
                        }
                    </row>
                </account-settings>
            );
        }

        return (<account-settings />);
    }

    renderButton = () => {
        return (
            <column className='is-12'>
                <button
                    className={`button ${this.props.settings.dirty && !this.props.settings.error ? '' : 'disabled'}`}
                    disabled={!this.props.settings.dirty || this.props.settings.error}
                    onClick={this.submit}
                >
                    SAVE CHANGES
                </button>
                {this.renderMessage()}
            </column>
        );
    }

    renderMessage = () => {
        if (this.props.settings.success) {
            return (<p className='is-success'>Your changes have been saved!</p>);
        }

        return null;
    }

    handleChange = (name, value, error = null, formError = null) => {
        const fields = this.props.settings.fields;
        const errors = this.props.settings.errors;

        if (name) {
            fields[name] = value || null;

            if (error) {
                errors[name] = error;
            } else if (errors[name]) {
                delete errors[name];
            }
        }

        this.setState({ errors: Object.keys(errors).length });

        this.props.settingsUpdate({
            success: false,
            errors: errors,
            fields: fields,
            error: Object.keys(errors).length || formError,
            dirty: Object.keys(fields).length,
        });
    }

    submit = (e) => {
        e.preventDefault();
        this.props.memberUpdate();
    }

    scrollTo = (e) => {
        const hash = e.target.nodeName == 'A' ? e.target.hash : e.target.parentNode.hash;

        if ((MQ.isMobile() || MQ.isTablet()) && hash) {
            e.preventDefault();
            this.props.routeTo(hash.replace('#', ''));
            setTimeout(() => {
                smoothScrollToElement(document.querySelector(hash));
            }, 100);
        }
    }
}

const mapStateToProps = (state) => ({
    route: state.route,
    user: state.user,
    settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
    getDetails: () => dispatch({ type: 'member:get-details' }),
    memberUpdate: () => dispatch({ type: 'member:update-settings' }),
    routeTo: (hash) => dispatch({ type: 'route:to', payload: hash }),
    settingsUpdate: (payload) => dispatch({ type: 'settings:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);